module.exports = __webpack_public_path__ + "img/4510.cd0e6210.png";